import { render, staticRenderFns } from "./ModificarPrepedido.vue?vue&type=template&id=10a08505&scoped=true"
import script from "./ModificarPrepedido.vue?vue&type=script&lang=js"
export * from "./ModificarPrepedido.vue?vue&type=script&lang=js"
import style0 from "./ModificarPrepedido.vue?vue&type=style&index=0&id=10a08505&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a08505",
  null
  
)

export default component.exports